// Various functions pulled from the internal react-table utils package - useful
// when pulling hooks from the main repo before changing them.

import type { PluginHook, Row } from "react-table";
import {
    useColumnOrder,
    useSortBy,
    useExpanded,
    usePagination,
    useFilters,
    useGroupBy,
    useResizeColumns,
    useRowSelect,
    useRowState,
    useGlobalFilter,
    useBlockLayout,
    useAbsoluteLayout,
} from "react-table";
import { useFixedFlexLayout } from "./useFixedFlexLayout";

export const getRowId = <T extends { id: string }>(row: T, index: number, parent?: Row<T>) =>
    parent ? `${parent.id}.${row.id}` : row.id;

export const getTableHooks = <T extends object>({
    columnOrder = false,
    globalFilter = false,
    filters = false,
    groupBy = false,
    sortBy = true,
    expanded = false,
    pagination = false,
    resizeColumns = false,
    rowSelect = false,
    rowState = false,

    fixedFlexLayout = true,
    flexLayout = false,
    blockLayout = false,
    absoluteLayout = false,
} = {}) => {
    const plugins: Array<PluginHook<T>> = [];
    /* eslint @typescript-eslint/no-unused-expressions: ["error", { "allowShortCircuit": true }] */
    columnOrder && plugins.push(useColumnOrder);
    filters && plugins.push(useFilters);
    globalFilter && plugins.push(useGlobalFilter);
    groupBy && plugins.push(useGroupBy);
    sortBy && plugins.push(useSortBy);
    expanded && plugins.push(useExpanded);
    resizeColumns && plugins.push(useResizeColumns);
    rowSelect && plugins.push(useRowSelect);
    rowState && plugins.push(useRowState);
    pagination && plugins.push(usePagination);

    fixedFlexLayout && plugins.push(useFixedFlexLayout);
    flexLayout && plugins.push(useFixedFlexLayout);
    blockLayout && plugins.push(useBlockLayout);
    absoluteLayout && plugins.push(useAbsoluteLayout);
    return plugins;
};
